import React from "react";
import { NavLink, useNavigate } from "react-router-dom";

function Navbar() {
  const navigate = useNavigate();
  function logout() {
    localStorage.clear("auth-token");
    navigate("/");
  }
  return (
    <nav className="navbar">
      <NavLink to={"/home"}>home</NavLink>

      <span style={{ cursor: "pointer" }} onClick={logout}>
        logout
      </span>
    </nav>
  );
}

export default Navbar;
